import { IsUUID } from 'class-validator';

export class ConfirmarPagoMockDto {
  @IsUUID('4', { message: 'pagoId debe ser un UUID válido' })
  pagoId: string;
}
